import { MainHeader, Section } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import { PRODUCT_PET } from '@/utils/products';
import { Flex, fadeInAnimation, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled from 'styled-components';
import { DiscountBanner } from './DiscountBanner';
import PetAnimation from './PetAnimation';
import ScrollArrow from './ScrollArrow';

const TopSectionContainer = styled(Section)`
  pointer-events: none;
  position: relative;
  background-color: transparent;
  z-index: 2;
  ${MEDIA_QUERIES.tabletAndDesktop`
        height: calc(100vh - 100px);
    `}
`;

const StyledTitle = styled(MainHeader)`
  ${font('alt', { lineHeight: '3.6rem', fontSize: '2.8rem' })}
  margin: 0 29px;
  text-transform: capitalize;

  ${MEDIA_QUERIES.tabletAndDesktop`
        white-space: pre;
        ${font('alt', {
          fontSize: '5.0rem',
          lineHeight: '6.1rem',
          fontWeight: 'normal',
        })};
    `}
`;

const Subtitle = styled.h5`
  text-align: center;
  margin: 20px 39px 0px;
  ${font('main', {
    lineHeight: '2.8rem',
    fontSize: '2.0rem',
    fontWeight: 'normal',
  })};
`;

const SubtitleInner = styled(Flex)`
  animation: ${fadeInAnimation} 0.3s ease-in;
`;

export const MainCTA = styled(JoinCTA)`
  margin-top: 56px;
  width: 233px;

  ${MEDIA_QUERIES.mobile`
            margin-top: 28px;
    `}
`;

const ContentContainer = styled(Flex)`
  position: relative;
  top: -20%;
`;

const ScrollArrowContainer = styled.div`
  width: 30px;
  position: relative;

  ${MEDIA_QUERIES.tabletAndDesktop`
        width: 42px;
    `}

  @media (max-height: 755px) {
    display: none;
  }
`;

const StyledScrollArrow = styled(ScrollArrow)`
  position: absolute;
  top: 100px;
  left: auto;
  right: auto;

  ${MEDIA_QUERIES.tabletAndDesktop`
        top: 120px;
    `}
`;

const PetAnimationContainer = styled(Flex)`
  height: calc(330px + 150 * (667px - 100vh) / -145); /* lerp in css! */
  min-height: 400px;
  pointer-events: none;
  position: relative;
  width: 150%;
  margin-bottom: 20px;

  ${font('alt', { fontSize: '2.0rem' })}
  ${MEDIA_QUERIES.tabletAndDesktop`
        height: 100vh;
        position: absolute;
        bottom: 150px;
    `};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    left: -25%;
    right: 0;
    width: 150%;
  }
`;

const TopSection: React.FC = () => {
  return (
    <TopSectionContainer justifyContent="center" mt={[0, 40]}>
      <ContentContainer flexDirection="column" alignItems="center">
        <StyledTitle>Pet insurance with\nsuper fast everything</StyledTitle>
        <Subtitle>
          <SubtitleInner>Sign up in seconds. Get paid in minutes. Award-winning service.</SubtitleInner>
        </Subtitle>
        <MainCTA
          size="big"
          flavor="primary"
          id="gtm_button_pet_check_prices"
          glowing
          data-source="pet"
          product={PRODUCT_PET}
          analyticsParams={{ position: 'center' }}
        >
          Check our prices
        </MainCTA>
        <DiscountBanner />
        <ScrollArrowContainer>
          <StyledScrollArrow />
        </ScrollArrowContainer>
      </ContentContainer>
      <PetAnimationContainer flexDirection="row" justifyContent={['space-around', 'center']}>
        <PetAnimation />
      </PetAnimationContainer>
    </TopSectionContainer>
  );
};

export default TopSection;
